/* Age guidance and sticky sample-kit action. Purchase popups use the shared sample controller. */
(function () {
  'use strict';
  if (window.__fizzySampleV2) return;
  window.__fizzySampleV2 = true;

  var instances = new Map();
  var guidance = {
    kids: { label: 'Ages 8–13', serving: '1 serving daily' },
    teens: { label: 'Ages 14–17', serving: '2 servings daily' },
    adults: { label: 'Ages 18+', serving: '2 servings daily' }
  };

  function initSticky(root) {
    var sticky = root.querySelector('[data-sv-sticky]');
    var heroButton = root.querySelector('.sv-hero [data-fsk-popup-open], .sv-hero a.sv-button');
    var offer = root.querySelector('.sv-offer');
    if (!sticky || !heroButton || !offer) return function () {};
    var header = document.querySelector('.gh');
    var signupForm = sticky.querySelector('[data-fsk-klaviyo-form]');
    var formId = signupForm ? signupForm.getAttribute('data-fsk-klaviyo-form') : null;
    var frame = 0;
    var focusFrame = 0;
    var popupOpen = false;
    var restoreFocus = false;
    var previousStickyHeight = document.documentElement.style.getPropertyValue('--fizzy-sample-sticky-height');
    var measuredStickyHeight = 0;
    sticky.hidden = false;

    function sync() {
      window.cancelAnimationFrame(frame);
      frame = 0;
      var headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var stickyHeight = sticky.offsetHeight;
      if (stickyHeight !== measuredStickyHeight) {
        measuredStickyHeight = stickyHeight;
        document.documentElement.style.setProperty('--fizzy-sample-sticky-height', stickyHeight + 'px');
      }
      // Keep the final offer and footer clear once the inline offer is reached.
      var visible = !popupOpen && heroButton.getBoundingClientRect().bottom <= headerBottom && offer.getBoundingClientRect().top > viewportHeight;
      sticky.classList.toggle('is-visible', visible);
      sticky.inert = !visible;
    }
    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(sync);
    }
    function onClick(event) {
      var trigger = event.target.closest('[data-fsk-popup-open]');
      if (trigger) restoreFocus = sticky.contains(trigger);
    }
    function onPopup(event) {
      var detail = event.detail || {};
      if (!formId || String(detail.formId) !== formId) return;
      if (detail.type !== 'open' && detail.type !== 'close') return;
      window.cancelAnimationFrame(focusFrame);
      popupOpen = detail.type === 'open';
      sync();
      if (!popupOpen && restoreFocus && !sticky.inert) {
        // Let the provider release its scroll lock before focusing the trigger.
        focusFrame = window.requestAnimationFrame(function () {
          focusFrame = window.requestAnimationFrame(function () {
            focusFrame = 0;
            if (popupOpen || sticky.inert || !sticky.isConnected) return;
            var action = sticky.querySelector('[data-fsk-popup-open], a.sv-button');
            if (action) action.focus({ preventScroll: true });
            restoreFocus = false;
          });
        });
      }
    }
    var observer = 'IntersectionObserver' in window ? new IntersectionObserver(schedule) : null;
    if (observer) {
      observer.observe(heroButton);
      observer.observe(offer);
    }
    var resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;
    if (resizeObserver) {
      resizeObserver.observe(root);
      resizeObserver.observe(sticky, { box: 'border-box' });
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('klaviyoForms', onPopup);
    root.addEventListener('click', onClick);
    sync();
    return function () {
      window.cancelAnimationFrame(frame);
      window.cancelAnimationFrame(focusFrame);
      if (observer) observer.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      window.removeEventListener('pageshow', schedule);
      window.removeEventListener('klaviyoForms', onPopup);
      root.removeEventListener('click', onClick);
      sticky.hidden = true;
      sticky.inert = true;
      if (previousStickyHeight) document.documentElement.style.setProperty('--fizzy-sample-sticky-height', previousStickyHeight);
      else document.documentElement.style.removeProperty('--fizzy-sample-sticky-height');
    };
  }

  function initStoryOrder(root) {
    // Section order is defined by the Liquid markup at every breakpoint.
    return function () {};
  }

  function initCountdown(root) {
    var found = Array.prototype.slice.call(root.querySelectorAll('[data-sv-countdown]'));
    var clocks = [];
    found.forEach(function (el) {
      var deadline = Date.parse(el.getAttribute('data-sv-deadline'));
      if (!deadline) return;
      var cells = {
        d: el.querySelector('[data-sv-cd="d"]'),
        h: el.querySelector('[data-sv-cd="h"]'),
        m: el.querySelector('[data-sv-cd="m"]'),
        s: el.querySelector('[data-sv-cd="s"]')
      };
      if (!cells.d || !cells.h || !cells.m || !cells.s) return;
      clocks.push({ el: el, deadline: deadline, cells: cells });
    });
    if (!clocks.length) return function () {};
    var offerDeadline = root.querySelector('[data-sv-offer-deadline]');
    var offerExpired = false;
    function expireOffer() {
      if (!offerDeadline || offerExpired) return;
      offerExpired = true;
      offerDeadline.querySelector('[data-sv-deadline-title]').textContent = 'Samples now come with your first subscription';
      offerDeadline.querySelector('.sv-deadline__note').textContent = 'Explore FizzyFocus subscription plans to get started.';
      root.querySelectorAll('[data-fsk-popup-open]').forEach(function (button) {
        if (button.classList.contains('sv-kit-flavor__trigger')) button.setAttribute('aria-label', 'Explore FizzyFocus subscriptions');
        else button.textContent = 'Explore subscriptions →';
      });
      var intro = root.querySelector('.sv-intro');
      if (intro) intro.textContent = 'Cognitive nutrition intervention, in a drink they’ll ask for. Samples of all four flavors are included with your first subscription box.';
      var offerHeading = root.querySelector('.sv-kit-offer h3');
      if (offerHeading) offerHeading.textContent = 'All four flavors in your first box.';
      var shipping = root.querySelector('.sv-kit-offer__shipping');
      if (shipping) shipping.textContent = 'Samples included with your first subscription order.';
      var sticky = root.querySelector('.sv-sticky__price strong');
      if (sticky) sticky.textContent = 'Samples included';
      var stickyNote = root.querySelector('.sv-sticky__note');
      if (stickyNote) stickyNote.textContent = 'with your first subscription';
    }
    function routeExpiredOffer(event) {
      if (!offerDeadline || Date.now() < Date.parse(offerDeadline.dataset.svOfferDeadline)) return;
      var trigger = event.target.closest('[data-fsk-popup-open]');
      if (!trigger || !root.contains(trigger)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign('/products/fizzyfocus');
    }
    root.addEventListener('click', routeExpiredOffer, true);
    var tick = null;

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function set(cell, value) {
      if (cell.textContent !== value) cell.textContent = value;
    }

    // The clocks are aria-hidden and the hero block carries a static sentence with the
    // real date, so a screen reader hears the deadline once instead of every second.
    function render() {
      var running = 0;
      clocks.forEach(function (clock) {
        var left = clock.deadline - Date.now();
        if (left <= 0) { clock.el.hidden = true; expireOffer(); return; }
        running += 1;
        var total = Math.floor(left / 1000);
        set(clock.cells.d, String(Math.floor(total / 86400)));
        set(clock.cells.h, pad(Math.floor(total / 3600) % 24));
        set(clock.cells.m, pad(Math.floor(total / 60) % 60));
        set(clock.cells.s, pad(total % 60));
      });
      if (!running) stop();
    }

    function stop() {
      if (tick) { window.clearInterval(tick); tick = null; }
    }

    function start() {
      render();
      if (!tick && clocks.some(function (c) { return !c.el.hidden; })) {
        tick = window.setInterval(render, 1000);
      }
    }

    // A backgrounded tab throttles the interval, so re-render on return rather than
    // letting the clock drift visibly behind.
    function onVisibility() {
      if (document.hidden) stop(); else start();
    }

    start();
    document.addEventListener('visibilitychange', onVisibility);
    return function () {
      stop();
      document.removeEventListener('visibilitychange', onVisibility);
      root.removeEventListener('click', routeExpiredOffer, true);
    };
  }

  function init(root) {
    if (instances.has(root)) return;
    var buttons = Array.from(root.querySelectorAll('[data-sv-age]'));
    if (!buttons.length) return;
    var panel = root.querySelector('[data-sv-age-panel]');
    if (panel) {
      panel.setAttribute('aria-live', 'polite');
      panel.setAttribute('aria-atomic', 'true');
    }

    function select(age) {
      if (!Object.prototype.hasOwnProperty.call(guidance, age)) return;
      var current = guidance[age];
      root.setAttribute('data-age', age);
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.getAttribute('data-sv-age') === age));
      });
      root.querySelectorAll('[data-sv-age-label]').forEach(function (label) {
        label.textContent = current.label;
      });
      root.querySelectorAll('[data-sv-serving]').forEach(function (serving) {
        serving.textContent = current.serving;
      });
      root.querySelectorAll('[data-sv-age-note]').forEach(function (note) {
        note.textContent = 'Mix each serving into 6–8 oz of cold water.';
      });
    }

    function onClick(event) {
      var button = event.target.closest('[data-sv-age]');
      if (!button || !root.contains(button) || button.disabled) return;
      select(button.getAttribute('data-sv-age'));
    }

    var active = buttons.find(function (button) {
      return button.getAttribute('aria-pressed') === 'true';
    });
    var initial = root.getAttribute('data-age') || (active && active.getAttribute('data-sv-age'));
    select(Object.prototype.hasOwnProperty.call(guidance, initial) ? initial : 'kids');
    var cleanupStoryOrder = initStoryOrder(root);
    var cleanupSticky = initSticky(root);
    var cleanupCountdown = initCountdown(root);
    root.addEventListener('click', onClick);
    instances.set(root, function () {
      cleanupStoryOrder();
      cleanupSticky();
      cleanupCountdown();
      root.removeEventListener('click', onClick);
    });
  }

  function scan(scope) {
    if (scope.matches && scope.matches('[data-sample-v2]')) init(scope);
    scope.querySelectorAll('[data-sample-v2]').forEach(init);
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    instances.forEach(function (dispose, root) {
      if (event.target === root || event.target.contains(root)) {
        dispose();
        instances.delete(root);
      }
    });
  });
})();
